export const version = '1.21.1';
//# sourceMappingURL=version.js.map